import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material';

interface IconAvatarProps {
  size?: 'small' | 'medium';
  backgroundColor?: string;
}

export const IconAvatar = styled('div')<IconAvatarProps>(
  ({ theme, size = 'small', backgroundColor }) => ({
    width: size === 'small' ? '24px' : '40px',
    height: size === 'small' ? '24px' : '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: backgroundColor || alpha(theme.palette.primary.main, 0.5),
  })
);
